import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Snackbar} from "../../../../../util/snackbar";
import {MemberProvider} from "../../../../../providers/company/member/member";
import {PessoaFiscalDTO} from "../../../../../model/dto/PessoaFiscalDTO";
import {HttpErrorResponse} from "@angular/common/http";
import {ErrorUtil} from "../../../../../util/error";

@Component({
  selector: 'app-deletar-socio',
  templateUrl: './deletar-socio.component.html',
  styleUrls: ['./deletar-socio.component.scss']
})
export class DeletarSocioComponent implements OnInit {
  enviando: boolean = false;

  constructor(public dialogRef: MatDialogRef<DeletarSocioComponent>,
              public memberProvider: MemberProvider,
              public errorUtil: ErrorUtil,
              public  snackbar: Snackbar,
              @Inject(MAT_DIALOG_DATA) public data: PessoaFiscalDTO) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close("cancelou");
  }

  onYesClick(): void {
    this.enviando = true;
    this.memberProvider.deleteMember(+localStorage.getItem('idEmpresa'), this.data.cpfCNPJ).then(() => {
      this.dialogRef.close(this.data);
      this.snackbar.openLong('Excluído com sucesso!', 'success');
    }).catch((result: HttpErrorResponse) => {
      this.enviando = false;
      console.error(result);
      this.snackbar.openLong(result.error.status + ' - ' + result.error.detail, 'erro');
    })
    ;
  }
}
